var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.639 10.237a1.501 1.501 0 0 1-.877-.876l-2.761-7.36h-17.5A1.5 1.5 0 0 0 5 3.5v37A1.5 1.5 0 0 0 6.5 42h27a1.5 1.5 0 0 0 1.5-1.502V13l-7.361-2.762Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fillOpacity: 0.35,
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.29 24.14a1 1 0 0 1 .757.346l3.198 3.706 1.065-1.233c.196-.228.47-.397.783-.346a.996.996 0 0 1 .764.386l3.402 4.388a.996.996 0 0 1 .107 1.053.992.992 0 0 1-.897.56H12.533a.99.99 0 0 1-.905-.577.99.99 0 0 1 .14-1.066l5.757-6.86a.993.993 0 0 1 .758-.356l.007-.001Zm0 1L12.533 32h14.935l-3.4-4.388-1.444 1.673a.5.5 0 0 1-.758-.001L18.29 25.14ZM24.5 21a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z",
    fill: "#FFF"
  }))));
};
export default SvgImage;